import { faCopy, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons"
import { Fragment, useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import { useDispatch, useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import Backdrop from "../../../Backdrop"
import Filter from "./desktop/filter"
import Resort from './desktop/resort'
import InfoIcon from "../../../InfoIcon"
import useFetch from "../../../../hook/useFetch"
import { notificationActions } from "../../../../store/notification-slice"


export default function DesktopComponent() {


    const [desktopItems, setDesktopItems] = useState()


    let filteredproducts = useSelector((state) => state.product.filteredProducts)

    let stateproducts = useSelector(state => state.product.products)


    useEffect(() => {

        let items = []
        let products = filteredproducts ?? stateproducts

        if (products && Object.keys(products).length > 0) {

            products.forEach((product) => {

                items.push(<DesktopItem key={product.id} product={product} />)

            })
        }
        setDesktopItems(items)



    }, [filteredproducts, stateproducts])


    if (!desktopItems) {
        return <Skeleton count={50} />
    }

    return <Fragment>
        <Filter>

            <div className="table-responsive dashboard-data-table-scroll">
            <table className="table table-striped table-bordered dashboard-data-table" >
                <thead>
                    <tr>

                        <th>Title <Resort type='title' /></th>
                        <th>Active <Resort type='active' /></th>
                        <th>Type <Resort type='type' /></th>
                        <th>Start <Resort type='start' /></th>
                        <th>End <Resort type='end' /></th>

                        <th className="table-actions product-table-actions">Actions</th>


                    </tr>
                </thead>
                <tbody>
                    {desktopItems}
                </tbody>
            </table>
            </div>
        </Filter>
        <Backdrop />

    </Fragment>
}


function DesktopItem(props) {
    const { product } = props
    const {del,post}=useFetch()

    
    let dispatch=useDispatch()

    let navigate=useNavigate()

    return <Fragment>

        <tr>

            <td>
                {product.title}
            </td>
            <td>
                {product.active?'true':'false'}
            </td>
            <td>
            <Link to={`/admin/producttypes/${product.product_type_id}`} >{product.ptype}</Link>
            </td>
            <td>
                {product.start}
            </td>
            <td>
                {product.end}
            </td>
            <td className="table-actions product-table-actions">
                <div className="table-action-buttons">
                <Link className="btn btn-outline-secondary bgnt product-action-button" to={`/admin/products/${product.id}`} aria-label="Edit product"><InfoIcon icon={faEdit} title='product details' /></Link>
               <button className="btn btn-warning product-action-button" type="button" aria-label="Delete product" onClick={()=>{
                del(`/admin/product`,{id:product.id},(data) => {
                                        dispatch(notificationActions.setNotification({
                                            message: data,
                                            status: false
                                        }))
                                    },
                                        () => {
                                            dispatch(notificationActions.setNotification({
                                                message: `Product deleted`,
                                                status: true
                                            }))
                
                                            navigate('/admin/products', {
                                                state: {
                                                    refetch: true
                                                }
                                            })
                                        })
               }} ><InfoIcon  icon={faTrash} /></button>
                 <button className="btn btn-secondary product-action-button" type="button" aria-label="Copy product" onClick={()=>{
                post(`/admin/product-copy`,{id:product.id},(data) => {
                                        dispatch(notificationActions.setNotification({
                                            message: data,
                                            status: false
                                        }))
                                    },
                                        () => {
                                            dispatch(notificationActions.setNotification({
                                                message: `Product copied`,
                                                status: true
                                            }))
                
                                            navigate('/admin/products', {
                                                state: {
                                                    refetch: true
                                                }
                                            })
                                        })
               }} ><InfoIcon  icon={faCopy} /></button>
                </div>
            </td>



        </tr>

    </Fragment>

}
